import { ref } from "vue";
export default {
  name: "Footer",
  setup: function setup() {
    var isShowDouYin = ref(false); //是否展示抖音二维码

    var isShowWeibo = ref(false); //是否展示微博二维码

    var isShowBzhan = ref(false); //是否展示B站二维码
    //鼠标移入展示微信二维码

    function showQR(id) {
      if (id == "android") {
        isShowDouYin.value = true;
      } else if (id == "apple") {
        isShowWeibo.value = true;
      } else {
        isShowBzhan.value = true;
      }
    } //鼠标离开隐藏微信二维码


    function hiddenQR() {
      isShowDouYin.value = false;
      isShowWeibo.value = false;
      isShowBzhan.value = false;
    } //回到顶部


    function toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }

    return {
      isShowDouYin: isShowDouYin,
      isShowWeibo: isShowWeibo,
      isShowBzhan: isShowBzhan,
      showQR: showQR,
      hiddenQR: hiddenQR,
      toTop: toTop
    };
  }
};